import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import {
  BEFORE_INPUT_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  COMPOSITION_END_COMMAND,
  COMPOSITION_START_COMMAND,
  COPY_COMMAND,
  CUT_COMMAND,
  DRAGSTART_COMMAND,
  DROP_COMMAND,
  INPUT_COMMAND,
  KEY_DOWN_COMMAND,
  PASTE_COMMAND,
  type LexicalCommand,
} from 'lexical';
import { FC, useEffect } from 'react';

import {
  isHistoryKeyOutsideTextBox,
  isNoteWidgetEvent,
} from '../noteEditorCommands';

const WIDGET_COMMANDS: LexicalCommand<Event | null>[] = [
  KEY_DOWN_COMMAND,
  BEFORE_INPUT_COMMAND,
  INPUT_COMMAND,
  COMPOSITION_START_COMMAND,
  COMPOSITION_END_COMMAND,
  PASTE_COMMAND,
  CUT_COMMAND,
  COPY_COMMAND,
  DRAGSTART_COMMAND,
  DROP_COMMAND,
] as LexicalCommand<Event | null>[];

// Keys, typing, composition, the clipboard and drags inside a hosted widget
// (its inputs, its option buttons) belong to the widget: the editor would
// otherwise act on its own last selection, and type, delete, paste or undo
// in the document instead of the widget's text box.
export const NoteWidgetEventsPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        ...WIDGET_COMMANDS.map((command) =>
          editor.registerCommand(
            command,
            (event) =>
              isNoteWidgetEvent(editor, event) &&
              !isHistoryKeyOutsideTextBox(event),
            COMMAND_PRIORITY_CRITICAL,
          ),
        ),
      ),
    [editor],
  );

  return null;
};
